import { useForm } from "@tanstack/react-form";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { useCreateWarehouse, useUpdateWarehouse } from "@/hooks/use-warehouse";
import { toast } from "sonner";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  warehouse?: any;
};

export function WarehouseDialog({ open, onOpenChange, warehouse }: Props) {
  const isEdit = !!warehouse;
  const createMut = useCreateWarehouse();
  const updateMut = useUpdateWarehouse();

  const form = useForm({
    defaultValues: {
      name: warehouse?.name ?? "",
      description: warehouse?.description ?? "",
      position: warehouse?.position ?? 0,
    },
    onSubmit: async ({ value }) => {
      try {
        if (isEdit) {
          await updateMut.mutateAsync({ id: warehouse.id, ...value });
          toast.success("Skladište ažurirano");
        } else {
          await createMut.mutateAsync(value);
          toast.success("Skladište kreirano");
        }
        onOpenChange(false);
      } catch (e: any) {
        toast.error(e.message || "Greška");
      }
    },
  });

  const isPending = createMut.isPending || updateMut.isPending;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" key={warehouse?.id ?? "new"}>
        <DialogHeader>
          <DialogTitle>{isEdit ? "Uredi skladište" : "Novo skladište"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={(e) => { e.preventDefault(); form.handleSubmit(); }} className="flex flex-col gap-3">
          <div className="flex flex-col gap-1.5">
            <Label>Naziv</Label>
            <form.Field name="name">
              {(field) => (
                <Input value={field.state.value} onChange={(e) => field.handleChange(e.target.value)} required />
              )}
            </form.Field>
          </div>
          <div className="flex flex-col gap-1.5">
            <Label>Opis</Label>
            <form.Field name="description">
              {(field) => (
                <Input value={field.state.value} onChange={(e) => field.handleChange(e.target.value)} />
              )}
            </form.Field>
          </div>
          <div className="flex flex-col gap-1.5">
            <Label>Pozicija</Label>
            <form.Field name="position">
              {(field) => (
                <Input type="number" value={field.state.value} onChange={(e) => field.handleChange(Number(e.target.value))} />
              )}
            </form.Field>
          </div>
          <DialogFooter>
            <Button type="submit" disabled={isPending}>
              {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              {isEdit ? "Sačuvaj" : "Kreiraj"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
